/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Вид для tooltip элементов.
   */
  app.TooltipView = app.View.extend({
    el: '.js-prop',
    
    run: function (options) {
      var cssClass = options.cssClass || '';
      
      this.$el.tooltip({
        position: {
          my: 'center bottom-20',
          at: 'center top'
        },
        
        tooltipClass: 'b-tooltip b-tooltip_abs b-tooltip_dark ' + cssClass
      });
    }
  });
})();

}.call(window));